import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CategoryType } from "../../../types/Library";

const initialState: CategoryType = {
    description: '',
  };

  const categorySlice = createSlice({
    name: 'category',
    initialState,
    reducers: {
      setCategoryData: (state, action: PayloadAction<CategoryType>) => {
        return { ...state, ...action.payload };
      },
      resetCategoryData: () => {
        return initialState;
      },
    },
  });

export const { setCategoryData, resetCategoryData } = categorySlice.actions;
export default categorySlice.reducer;